import React, { useEffect, useRef, useState } from "react";
import { X } from "@phosphor-icons/react";
import { toast } from "sonner";

// interface PopUpProps {
//   isVisible: boolean;
//   onClose: () => void;
//   title: string;
//   children: React.ReactNode;
// }

const PopUp = ({
  isVisible,
  onClose,
  title,
  children,
}) => {
  const popUpRef = useRef(null);
  const [slowProops, setProops] = useState(false);

  const handleClose = () => {
    setProops(true);
    onClose();
    setTimeout(() => {
      setProops(false);
    }, 300);
  };

  const handleClickOutside = (event) => {
    try {
        if(popUpRef !== null ){
            if(popUpRef.current){
                if (  !popUpRef.current.contains(event.target)) {
                  handleClose();
                }
            }
        }
        
    } catch (error) {
        toast.error(error.message)
    }
  };

  useEffect(() => {
    if (isVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed top-0 left-0 h-full bg-slate-50 bg-opacity-80 w-full z-50 flex justify-center items-center ${
        !slowProops ? "fadeIn3" : "fadeOut"
      }`}
    >
      <div
        ref={popUpRef}
        className=" bg-slate-50 bg-color-primary w-80 rounded-2xl shadow-xl p-4"
      >
        <div className="flex justify-between items-center">
          <p className="font-bold text-lg">{title}</p>
          <X
            size={18}
            weight="bold"
            className="cursor-pointer"
            onClick={handleClose}
          />
        </div>
        {children}
      </div>
    </div>
  );
};

export default PopUp;